module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fl border-box h-95p",
    style: ('width:' + _vm.width)
  }, [_c('div', {
    staticClass: "bor-deep-gra bg-wh h-100p ovf-auto"
  }, [_c('p', {
    staticClass: "p-t-20 p-b-20 p-l-20 m-t-0 m-b-0 bor-b-gray fw-b"
  }, [_vm._v("配置项")]), _vm._v(" "), _c('div', {
    staticClass: "p-t-20 p-l-30"
  }, [(_vm.curInput.default && !_vm.curInput.default.type) ? _c('div', [_vm._v("请选择控件")]) : _vm._e(), _vm._v(" "), (_vm.curInput.default && _vm.curInput.default.type) ? _c('common-config', {
    attrs: {
      "curInput": _vm.curInput,
      "inputList": _vm.inputList,
      "showName": _vm.showName
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curInput.default && _vm.curInput.default.type == _vm.TYPE_INPUTTEXT) ? _c('text-config', {
    attrs: {
      "curInput": _vm.curInput
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curInput.default && _vm.curInput.default.type == _vm.TYPE_PASSWORD) ? _c('password-config', {
    attrs: {
      "curInput": _vm.curInput
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curInput.default && _vm.curInput.default.type == _vm.TYPE_TEXTAREA) ? _c('textarea-config', {
    attrs: {
      "curInput": _vm.curInput
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curInput.default && _vm.curInput.default.type == _vm.TYPE_RADIO) ? _c('radio-config', {
    attrs: {
      "curInput": _vm.curInput
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curInput.default && _vm.curInput.default.type == _vm.TYPE_CHECKBOX) ? _c('checkbox-config', {
    attrs: {
      "curInput": _vm.curInput
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curInput.default && _vm.curInput.default.type == _vm.TYPE_SELECT) ? _c('select-config', {
    attrs: {
      "curInput": _vm.curInput
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curInput.default && _vm.curInput.default.type == _vm.TYPE_DATE) ? _c('date-config', {
    attrs: {
      "curInput": _vm.curInput
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curInput.default && _vm.curInput.default.type == _vm.TYPE_BOTH_DATE_TIME) ? _c('datetime-config', {
    attrs: {
      "curInput": _vm.curInput
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curInput.default && _vm.curInput.default.type == _vm.TYPE_TIME) ? _c('time-config', {
    attrs: {
      "curInput": _vm.curInput
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curInput.default && _vm.curInput.default.type == _vm.TYPE_FILE) ? _c('file-config', {
    attrs: {
      "curInput": _vm.curInput
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curInput.default && _vm.curInput.default.type == _vm.TYPE_EDITOR) ? _c('editor-config', {
    attrs: {
      "curInput": _vm.curInput
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curInput.default && _vm.curInput.default.type == _vm.TYPE_STRUCT) ? _c('struct-config', {
    attrs: {
      "curInput": _vm.curInput
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curInput.default && _vm.curInput.default.type == _vm.TYPE_PERSON) ? _c('people-config', {
    attrs: {
      "curInput": _vm.curInput
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curInput.default && _vm.curInput.default.type == _vm.TYPE_FOREIGNKEY) ? _c('foreignkey-config', {
    attrs: {
      "curInput": _vm.curInput,
      "inputList": _vm.inputList
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curInput.default && _vm.curInput.default.type == _vm.TYPE_CASCADER) ? _c('cascader-config', {
    attrs: {
      "curInput": _vm.curInput
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curInput.default && _vm.curInput.default.type == _vm.TYPE_SUBFORM) ? _c('subform-config', {
    attrs: {
      "curInput": _vm.curInput
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curInput.default && _vm.curInput.default.type == _vm.TYPE_USER) ? _c('userInfo-config', {
    attrs: {
      "curInput": _vm.curInput
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curInput.default && _vm.curInput.default.type == _vm.TYPE_DEALTIME) ? _c('dealtime-config', {
    attrs: {
      "curInput": _vm.curInput
    }
  }) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7433ddea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/instance/inputConfig.vue
// module id = 1924
// module chunks = 2